import Modal from "../../../components/Modal";
import PageHeader from "../../../components/PageHeader";
import PageActions from "../../../components/PageActions";
import Table from "../../../components/Table";
import Pagination from "../../../components/Pagination";
import FilterModal from "../../../components/FilterModal";

import MetaColetivaForm from "./components/MetaColetivaForm";
import MetaAtingidaBadge from "./components/MetaAtingidaBadge";
import ObservacoesModal from "./components/ObservacoesModal";
import { BrazilDate } from "../../../utils/BrazilDate";

import { metaColetivaFilterFields } from "./constants/filterFields";
import {
  MetaColetivaProvider,
  useMetaColetiva,
} from "./context/MetaColetivaContext";
import { useState } from "react";

import { createTableActions } from "../../../utils/tableActions";

const MetaColetivaContent = () => {
  const {
    filters,
    lojas,
    isOpen,
    editingItem,
    openModal,
    closeModal,
    handleFieldChange,
    handleSearch,
    handleClear,
    metasColetivas,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    setCurrentPage,
    isLoading,
    handleSubmit,
    handleEdit,
    handleDelete,
  } = useMetaColetiva();

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const activeFiltersCount = Object.values(filters).filter(
    (value) => value !== null && value !== undefined && value !== ""
  ).length;

  const formatDate = (dateString: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return BrazilDate.formatBR(date, false);
  };

  const tableActions = createTableActions(handleEdit, handleDelete);

  const filterFields = metaColetivaFilterFields.map((field) => {
    const baseField = {
      ...field,
      value: filters[field.name as keyof typeof filters] || "",
    };

    if (field.name === "lojaId") {
      return {
        ...baseField,
        options: lojas.map((loja: { id: number; nome: string }) => ({
          value: loja.id.toString(),
          label: loja.nome,
        })),
      };
    }

    return baseField;
  });

  return (
    <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-4 mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <PageHeader
          title="Gerenciar Metas Coletivas"
          description="Aqui você pode administrar todas as metas coletivas do sistema"
        />
        <PageActions
          onFilter={() => setIsFilterModalOpen(true)}
          onAdd={() => openModal()}
          addButtonText="Nova Meta Coletiva"
          activeFiltersCount={activeFiltersCount}
        />
      </div>

      <hr />

      <div className="overflow-x-auto pb-4">
        <div className="min-w-max">
          <Table
            headers={[
              "Loja",
              "Inicialização",
              "Produção",
              "Finalização",
              "Tempo Meta",
              "Tempo Real",
              "Erros Produção",
              "Meta Atingida (%)",
              "Data Criação",
              "Observações",
            ]}
            data={metasColetivas.map((meta: any) => [
              meta.loja?.nome || "-",
              meta.inicializacaoNota?.toFixed(1) || "-",
              meta.producaoNota?.toFixed(1) || "-",
              meta.finalizacaoNota?.toFixed(1) || "-",
              meta.tempoMeta || "-",
              meta.tempoReal || "-",
              meta.errosProducao || "0",
              <MetaAtingidaBadge value={meta.metaAtingida || 0} />,
              formatDate(meta.createdAt),
              <ObservacoesModal descricao={meta.observacao} />,
            ])}
            actions={tableActions}
          />
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              onPageChange={setCurrentPage}
            />
          )}
        </div>
      </div>

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        fields={filterFields}
        onFieldChange={handleFieldChange}
        onSearch={() => {
          handleSearch();
          setIsFilterModalOpen(false);
        }}
        onClear={handleClear}
      />

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        title={editingItem ? "Editar Meta Coletiva" : "Nova Meta Coletiva"}
      >
        {isOpen && (
          <MetaColetivaForm
            initialData={editingItem || undefined}
            onSubmit={handleSubmit}
            onCancel={closeModal}
            isLoading={isLoading}
            lojas={lojas}
          />
        )}
      </Modal>
    </main>
  );
};

const MetaColetiva = () => {
  return (
    <MetaColetivaProvider>
      <MetaColetivaContent />
    </MetaColetivaProvider>
  );
};

export default MetaColetiva;
